<cx-navigation-ui
  *ngIf="node$ | async as node"
  [node]="node"
  [flyout]="false"
  [ngClass]="(styleClass$ | async) ?? ''"
  [navAriaLabel]="'navigation.footerNavLabel' | cxTranslate"
></cx-navigation-ui>
